import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowRefService {
  private windowRef: any;

  constructor() {
    this.windowRef = window as any;
  }

  offsetHeight(): number {
    return this.windowRef.document.body.offsetHeight;
  }

  reload(): void {
    this.windowRef.document.location.reload();
  }

  buildFullHostLink(path: string): string {
    return `${this.windowRef.HOST_URL}${path}`;
  }

  get document() {
    return this.windowRef.document;
  }

  get AP() {
    return this.windowRef.AP;
  }

  get AJS() {
    return this.windowRef.AJS;
  }

  get HOST_URL() {
    return this.windowRef.HOST_URL;
  }

  get LOCAL_URL() {
    return this.windowRef.LOCAL_URL;
  }

  get TOKEN() {
    return this.windowRef.TOKEN;
  }

  get ISSUE_KEY() {
    return this.windowRef.ISSUE_KEY || 0;
  }

  copyToClipboard(text: string): any {
    if (this.windowRef.clipboardData && this.windowRef.clipboardData.setData) {
      // IE specific code path to prevent textarea being shown while dialog is visible.
      return this.windowRef.clipboardData.setData('Text', text);
    } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
      const textarea = document.createElement('textarea');
      textarea.textContent = text;
      textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
      document.body.appendChild(textarea);
      textarea.select();
      try {
        return this.windowRef.document.execCommand('copy');
      } catch (error) {
        console.warn('Copy to clipboard failed.', error);
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }
}
